import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel';
import ModalAlert from '../../components/ModalAlert';
import SummaryMaterialsTable from '../../components/SummaryMaterialsTable';
import fetch from '../../core/fetch';
import cx from 'classnames';
import Select from 'react-select';
import s from './EserviceSummary.css';
import _ from 'lodash';
import waiting from './waiting-wheel-300x300.gif';
import { connect } from 'react-redux';
import { countAction, fetchStatus, fetchPZGiKClaim } from '../../lib/utils';

const isBrowser = typeof window !== 'undefined' && window !== null;

const alignRight = {
  textAlign: 'right',
  width: '30%',
};

const servicesWithOnlyApplication = [
  'DecyzjaSrodowiskowa',
  'ZaswiadczenieEMUIA',
  'DecyzjaOWarunkachZabudowy',
];

const buttonPayStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

class EserviceSummary extends React.Component {
  calculateCost = () => {
    let totalCost = 0;
    this.props.claim.documents.forEach(element => {
      totalCost = parseFloat(element.cost) + parseFloat(totalCost);
    });
    return totalCost.toFixed(2);
  };

  state = {
    acceptApplication: false,
    isMounted: false,
    errorTitle: null,
    errorText: null,
    showError: false,
    paymentStatus: this.props.claim.paymentStatus,
    deliveryMethod: this.props.delivery_methods[0],
    paymentMethod: _.find(this.props.paymentMethods, (v, i) => {
      if (v.label == 'Płatność elektroniczna') {
        return v;
      }
    }) || this.props.paymentMethods[0],
    epuapAddress: '',
    wasAddressSuggested: false,
    isValidEpuapAddress: true,
    bankAccount: this.props.bankAccounts[0],
    deliveryMethods: this.props.delivery_methods,
    pzgik: null
  };

  epuapRegexString = '^[/][a-zA-Z0-9]{3,}[/][a-zA-Z0-9]{3,}';
  epuapRegex = new RegExp(this.epuapRegexString);

  componentDidMount = () => {
    this.getPZGiKClaim()
    this.setState({ isMounted: true });
  };

  getPZGiKClaim() {
    const pzgikList = ['UdostepnienieMaterialow', 'UdostepnienieMaterialowPublicznych'];
    if (!pzgikList.includes(this.props.claim.shortName)) return;
    fetchPZGiKClaim(this.props.claim.id)
    .then(resp => {
      this.setState({pzgik: resp})
    })
  }

  onHide = () => this.setState({ showError: !this.state.showError });
  changeApplicationState = () =>
    this.setState({ acceptApplication: !this.state.acceptApplication });
  changeEpuapAddress = e =>
    this.setState({ epuapAddress: e.target.value }, this.validateEpuapAddress);

  validateEpuapAddress = () =>
    this.setState({ isValidEpuapAddress: this.epuapRegex.test(this.state.epuapAddress) });

  checkPayableService = () => {
    let payableService = !this.props.eserviceDistrict.disablePayment ? this.props.eserviceDistrict : false;
    // lista uslug (hrubieszow), dla ktorych wylaczona jest platnosc
    // ale trzeba ją włączyć jeżeli dodano pełnomocnika do wniosku (wtedy doc.cost === 17zł)f
    if (this.props.eserviceDistrict.enableAgent) {
      let docsCost = 0;
      this.props.claim.documents.map((doc) => (
        docsCost += doc.cost
      ));
      if (docsCost > 0) {
        payableService = true;
      }
    }

    if (this.state.pzgik) {
      return this.isPayablePurposePzgik();
    }
    return payableService;
  }

  goToSign = () => {
    const payableService = this.checkPayableService();
    if (!this.state.deliveryMethod.id) return;
    if (payableService && !this.state.paymentMethod.id) return;
    if (this.state.deliveryMethod.label == 'Wysyłka EPUAP' && !this.state.isValidEpuapAddress) {
      this.setState({
        errorText:
          'Wprowadzony adres skrytki EPUAP nie jest prawidłowy, prosimy o poprawne wprowadzenie adresu skrytki.',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });
      return;
    }
    if (!this.props.eservices[this.props.claim.shortName].confirmText || this.state.acceptApplication) {
      let redirectURL = `${process.env.API_URL}/eservices/signDoc/${this.props.claim.jobId}?deliveryMethod=${this.state.deliveryMethod.id}`;

      if (payableService) {
        redirectURL += `&paymentMethod=${
          this.state.paymentMethod.id}`;
      }
      if (this.state.deliveryMethod.label == 'Wysyłka EPUAP') {
        redirectURL += `&epuapAddress=${this.state.epuapAddress}`;
      }
      redirectURL += `&bankAccountId=${this.state.bankAccount.id}`;
      countAction(this.props.claim.prefix, 4, 3, this.props.eserviceDistrict.fk_service)
      .then(() => {
        window.location.href = redirectURL;
      });
    } else {
      this.setState({
        errorText: 'Proszę o akceptację wymaganych pól. ',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });
    }
  };

  goToPayment = () => {
    const payableService = !this.props.eserviceDistrict.disablePayment;
    if (!this.state.deliveryMethod.id) return;
    if (payableService && !this.state.paymentMethod.id) return;
    if (this.state.deliveryMethod.label == 'Wysyłka EPUAP' && !this.state.isValidEpuapAddress) {
      this.setState({
        errorText:
          'Wprowadzony adres skrytki EPUAP nie jest prawidłowy, prosimy o poprawne wprowadzenie adresu skrytki.',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });
      return;
    }
    if (!this.props.eservices[this.props.claim.shortName].confirmText || this.state.acceptApplication) {
      let redirectURL = `${process.env.API_URL}/eservices/jobPayment/${
        this.props.claim.jobId
        }?deliveryMethod=${this.state.deliveryMethod.id}`
      if (payableService) {
        redirectURL += `&paymentMethod=${
          this.state.paymentMethod.id}`;
      }
      if (this.state.deliveryMethod.label == 'Wysyłka EPUAP') {
        redirectURL += `&epuapAddress=${this.state.epuapAddress}`;
      }
      redirectURL += `&bankAccountId=${this.state.bankAccount.id}`;
      window.location.href = redirectURL;
    } else {
      this.setState({
        errorText: 'Proszę o akceptację wymaganych pól. ',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });
    }
  };

  changeDelivery = e =>
    this.setState(
      { deliveryMethod: _.find(this.props.delivery_methods, v => v.id == e.target.value) },
      () => {
        if (this.state.deliveryMethod.label == 'Wysyłka EPUAP') {
          this.setState({ epuapAddress: `/${this.props.user.pzLogin}/domyslna` });
        }
      },
    );
  changePayment = (e) => {
    const value = e.target.value;
    this.setState(
      { paymentMethod: _.find(this.props.paymentMethods, v => v.id == value) },
      () => {
        if (this.props.claim.prefix === 'skierniewice' && _.find(this.props.paymentMethods, v => v.id == value).label === 'W kasie urzędu') {
          this.setState({ deliveryMethods: [_.find(this.props.delivery_methods, v => v.label === 'Odbiór osobisty')] });
        }
        else {
          this.setState({ deliveryMethods: this.props.delivery_methods });
        }
      }
    );
  }
  changeBankAccount = e =>
    this.setState({ paymentMethod: _.find(this.props.bankAccount, v => v.id == e.target.value) });

  renderDocumentsTable = () => (
    <table className="table table-hover">
      <thead>
        <tr>
          <th>Nazwa pliku</th>
          <th style={alignRight}>Wysokość opłaty</th>
        </tr>
      </thead>
      <tbody>
        {this.props.claim.documents.map((doc, i) => (
          <tr key={i} className={s.sectionBody}>
            <td>{doc.fileName}</td>
            <td style={alignRight}>{doc.cost.toFixed(2)}</td>
          </tr>
        ))}
        {this.props.claim.documents && this.props.claim.documents.length > 0 ? (
          <tr className={s.sectionBody} style={{ borderTop: 'solid 2px black' }}>
            <td>Suma</td>
            <td style={alignRight}>{this.calculateCost()}</td>
          </tr>
        ) : null}
      </tbody>
    </table>
  );

  renderApplicationTable = () => (
    <table className="table table-hover">
      <thead>
        <tr>
          <th>Nazwa pliku</th>
          <th style={alignRight}>Wysokość opłaty</th>
        </tr>
      </thead>
      <tbody>
        <tr className={s.sectionBody}>
          <td>{this.props.claim.wniosekFileName}</td>
          <td style={{ textAlign: 'right' }}>
            {this.props.eservices[this.props.claim.shortName].cost.toFixed(2)}
          </td>
        </tr>
      </tbody>
    </table>
  );

  pdfData = () => {
    const user = {
      AddressNumber: this.props.user.AddressNumber,
      AddressFlat: this.props.user.AddressFlat,
      AddressStreet: this.props.user.AddressStreet,
      AddressZipCode: this.props.user.AddressZipCode,
      AddressCity: this.props.user.AddressCity,
      FirstName: this.props.user.FirstName,
      LastName: this.props.user.LastName,
    };
    return {
      jobId: this.props.claim.jobId,
      user: user,
      bank: this.state.bankAccount,
      cost: this.calculateCost(),
      urzad: this.props.districts[this.props.claim.prefix]
    };
  }

  getPaymentStatus = paymentMethod => {
    // fetchStatus
    if (!this.state.disablePayment && paymentMethod.fk_method == '3' && this.state.paymentStatus === 'STARTED') {
      setTimeout(() => {
        fetchStatus(this.props.claim.jobId)
          .then(r => {
            if (r.status == 'STARTED') {
              this.getPaymentStatus(paymentMethod);
            } else {
              this.setState({ paymentStatus: r.status });
            }
          })
      }, 3000);
    }
  }

  renderPaymentStatus = (paymentMethod) => {
    /* {zmienic na skierniewice} */
    if (this.props.claim.prefix === 'skierniewice') {
      if (paymentMethod && (paymentMethod.fk_method == '3' && this.state.paymentStatus === 'STARTED')) {
        return (<b><span className="pull-right">Czekamy na odpowiedź z banku <img style={{ width: '48px', height: '48px' }} role="presentation" src={waiting} /></span></b>)
      }
      else {
        if (paymentMethod && (paymentMethod.fk_method == '3' && this.state.paymentStatus === 'SUCCESS')) {
          return (
            <span className="pull-left" style={{ color: 'green', padding: '17px 8px' }}><b>Wniosek został opłacony</b></span>
          )
        }
        else {
          if (paymentMethod && (paymentMethod.fk_method == '3' && this.state.paymentStatus === 'FAILURE')) {
            return (
              <span className="pull-left" style={{ color: 'red', padding: '17px 8px' }}>Nie udało się dokonać przelewu, prosimy zgłosić się do ekipy GIAP w celu weryfikacji zaistniałej sytuacji.</span>
            )
          }
          else {
            return (null)
          }
        }
      }
    }
  }

  renderPaymentDetails = (payableService) => {
    const receiptForm = this.state.pzgik ? 
    (<span>{this.state.pzgik.pzgik_claim_details[0].formaPrzekaz}</span>) :
    (<select
      className="form form-control"
      value={this.state.deliveryMethod.id}
      onChange={e => this.changeDelivery(e)}
    >
      {this.state.deliveryMethods.map((v, i) => (
        <option key={i} value={v.id}>
          {v.label}
        </option>
      ))}
    </select>) 
    //TODO poprawic gdy na BE będą bezpłatne
    if ((payableService && !this.state.pzgik) || (this.state.pzgik && this.isPayablePurposePzgik())) {
      return (<table className="table">
        <tbody>
          <tr style={{ height: '50px' }}>
            <td className={s.borderNone} style={{ padding: '17px 8px' }}>
              <b>Numer rachunku: {this.state.bankAccount && this.state.bankAccount.name ? this.state.bankAccount.name : '-'}</b>
            </td>
            <td className={s.borderNone} style={{ ...alignRight, paddingTop: '17px' }}>
              {/* <select className="form form-control" value={this.state.bankAccount.id} onChange={e => this.changeBankAccount(e)}>
            {this.props.bankAccounts.map((v, i) => <option key={i} value={v.id}>{v.name}</option>)}
          </select> */}
              {this.state.bankAccount.number}
            </td>
          </tr>
          <tr style={{ height: '50px' }}>
            <td className={s.borderNone} style={{ padding: '17px 8px' }}>
              <b>Forma płatności:</b>
            </td>
            <td className={s.borderNone} style={alignRight}>
              <select
                className="form form-control"
                value={this.state.paymentMethod.id}
                onChange={e => this.changePayment(e)}
              >
                {this.props.paymentMethods.map((v, i) => (
                  <option key={i} value={v.id}>
                    {v.label}
                  </option>
                ))}
              </select>
            </td>
          </tr>
          <tr>
            <td className={s.borderNone} style={{ padding: '17px 8px' }}>
              <b>Forma odbioru odpowiedzi na wniosek:</b>
            </td>
            <td className={s.borderNone} style={alignRight}>
              {receiptForm}
            </td>
          </tr>
          {this.state.deliveryMethod && this.state.deliveryMethod.label == 'Wysyłka EPUAP' ? (
            <tr style={{ height: '50px' }}>
              <td className={s.borderNone} style={{ padding: '17px 8px' }}>
                <b>Adres skrytki: </b>
              </td>
              <td className={s.borderNone} style={alignRight}>
                <input
                  className="form form-control"
                  type="text"
                  placeholder="/domyslna/LoginEPUAP"
                  value={this.state.epuapAddress}
                  onChange={e => this.changeEpuapAddress(e)}
                  style={!this.state.isValidEpuapAddress ? { borderColor: 'red' } : null}
                />
                {!this.state.isValidEpuapAddress ? (
                  <span style={{ fontSize: '10px', color: 'red' }}>
                    Nieprawidłowy adres skrytki EPUAP
              </span>
                ) : null}
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>)
    }
    else {
      return (
        <table className="table">
          <tbody>
            <tr>
              <td className={s.borderNone} style={{ padding: '17px 0px' }}>
                <b>Forma odbioru odpowiedzi na wniosek</b>
              </td>
              <td className={s.borderNone} style={alignRight}>
                {receiptForm}
              </td>
            </tr>
            {this.state.deliveryMethod.label == 'Wysyłka EPUAP' ? (
              <tr style={{ height: '50px' }}>
                <td className={s.borderNone} style={{ padding: '17px 0px' }}>
                  <b>Adres skrytki: </b>
                </td>
                <td className={s.borderNone} style={alignRight}>
                  <input
                    className="form form-control"
                    type="text"
                    placeholder="/domyslna/LoginEPUAP"
                    value={this.state.epuapAddress}
                    onChange={e => this.changeEpuapAddress(e)}
                    style={!this.state.isValidEpuapAddress ? { borderColor: 'red' } : null}
                  />
                  {!this.state.isValidEpuapAddress ? (
                    <span style={{ fontSize: '10px', color: 'red' }}>
                      Nieprawidłowy adres skrytki EPUAP
                          </span>
                  ) : null}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      )
    }
  }

  renderPaymentButtons = () => {
    if (this.state.paymentStatus === 'waiting') {
      return (
        <a
          className="btn btn-primary pull-right"
          onClick={() => this.goToPayment()}
          style={buttonPayStyle}>
          Zapłać
          </a>
      )
    }
    else if (this.state.paymentStatus === 'STARTED') {
      return (
        <button
          disabled
          onClick={() => this.goToSign()}
          className="btn btn-primary pull-right"
          style={buttonPayStyle}>
          Złóż wniosek
          </button>
      )
    }
    else if (this.state.paymentStatus === 'SUCCESS') {
      return (
        <button
          onClick={() => this.goToSign()}
          className="btn btn-primary pull-right"
          style={buttonPayStyle}>
          Złóż wniosek
          </button>
      )
    }
  }

  getRequestSubject = () => {
    let requestSubject = ''
    this.state.pzgik.przedmiotWniosku.split(",").forEach((elem,index) => {
      if((index+1)%2 !== 0){
        requestSubject += (index*1/2+1)+ ". " + elem
      } else { 
        requestSubject+=","+elem+" "
      }
    })
    return requestSubject
  }

  getDeliveryText = () => {
    const keys = Object.keys(this.props.districts);
    const urzad = keys[0];
    const workingHours = this.props.districts[urzad].workingHours.join(', ');
    const name = this.props.districts[urzad].placeOfSettling;
    const place = this.props.districts[urzad].place;
    const street = this.props.districts[urzad].street;
    let nrBuilding = this.props.districts[urzad].nrBuilding;
    const nrLocal = this.props.districts[urzad].nrLocal;
    const zipCode = this.props.districts[urzad].zipCode;

    if (nrLocal) {
      nrBuilding = `${nrBuilding}/${nrLocal}`;
    }

    const address = `${place} ul. ${street} ${nrBuilding}, ${zipCode}`

    const deliveryText = `Zamówienie będzie można odebrać w ${name} znajdującym się w ${address}. Urząd czynny jest w godzinach: ${workingHours}.`;

    return deliveryText;
  }

  getSummaryTextPzgik = () => {
    const shippingForm = this.state.pzgik.pzgik_claim_details[0].formaPrzekaz;
    const dataFormat = this.state.pzgik.pzgik_claim_details[0].formaMat;
    const dataSize = this.state.pzgik.rozmiarDanych;
    const dataSizeGiga = (((dataSize / 1024) / 1024) / 1024);
    const dataSizeMega = ((dataSize / 1024) / 1024);
    const dataSizeKilo = (dataSize / 1024);
    const deviceSizeGiga = (dataSizeGiga + 0.25).toFixed(2);
    const deviceSizeMega = (dataSizeMega + 250).toFixed(2);
    const deviceSizeKilo = (dataSizeKilo + (250 * 1024)).toFixed(2);
    let sizeText = '';
    let deviceSizeText = '';
    if (dataSizeGiga > 1) {
      sizeText = `${dataSizeGiga.toFixed(2)} GB`;
      deviceSizeText = `${deviceSizeGiga} GB`;
    } else if (dataSizeMega > 1) {
      sizeText = `${dataSizeMega.toFixed(2)} MB`;
      deviceSizeText = `${deviceSizeMega} MB`;
    } else {
      sizeText = `${dataSizeKilo.toFixed(2)} KB`;
      if (deviceSizeKilo > 1024) {
        if (deviceSizeMega > 1024) {
          deviceSizeText = `${deviceSizeGiga} GB`;
        } else {
          deviceSizeText = `${deviceSizeMega} MB`;
        }
      } else {
        deviceSizeText = `${deviceSizeKilo} KB`;
      }
    }
    let text = '';
    const deliveryText = this.getDeliveryText();
    //BEZPŁATNA
    if (!this.isPayablePurposePzgik()){
      text = `Operator systemu będzie weryfikował uprawnienia do udostępnienia materiałów geodezyjnych nieodpłatne w postaci elektronicznej. `
    }
    //ÞŁATNA, WEKTOR/RASTER
    else if ((shippingForm === "Udostępnienie na serwerze FTP WODGiK"|| shippingForm ===  "Wysyłka na wskazany adres e-mail") && dataFormat !== "drukowana"){
      return;
    } 
    // -> ODBIOR
    else if ((shippingForm === "Odbiór osobisty" || shippingForm === "Odbiór osobisty - własny nośnik") && this.props.claim.userDevice && dataFormat !== "drukowana") {
      text = `W celu odbioru materiału, konieczne będzie dostarczenie własnego nośnika.
      Informacja na temat pojemności zamówionego materiału zostanie przekazana w kolejnej wiadomości e-mail, po dokonaniu opłaty za materiał. `
      text += deliveryText
    } 
    else if ((shippingForm === "Odbiór osobisty" || shippingForm === "Odbiór osobisty - własny nośnik") && !this.props.claim.userDevice && dataFormat !== "drukowana") {
      if(dataSizeGiga < 4){
        text = deliveryText // <4
      }
      else if (dataSizeGiga >= 4 && dataSizeGiga < 20){
        text = `Twoje zamówienie będzie miało pojemność ${sizeText}. W związku z tym do wartości zamówienia został dodany koszt nośnika. `
        text += deliveryText // 4-20
      }
      else if (dataSizeGiga >= 20){
        text = "W celu odbioru materiału, konieczne będzie dostarczenie własnego nośnika. Informacja na temat pojemności zamówionego materiału zostanie przekazana w kolejnej wiadomości e-mail, po dokonaniu opłaty za materiał. "
        text += deliveryText // > 20
      }
    } 
    // -> WYSYŁKA
    else if ((shippingForm === "Wysyłka pod wskazany adres" || shippingForm === "Wysyłka pod wskazany adres - własny nośnik") && this.props.claim.userDevice && dataFormat !== "drukowana") {
      text = "Podana opłata jest opłatą podstawową.\
      Opłata podstawowa zostanie powiększona o doliczony koszt wysyłki pocztowej.\
      Koszt wysyłki pocztowej zostanie podany przez Operatora systemu.\
      Zostaniesz poinformowany o tym po złożeniu wniosku.\
      W celu odbioru materiału, konieczne będzie dostarczenie własnego nośnika. Informacja na temat pojemności zamówionego materiału zostanie przekazana w wiadomości e-mail, po dokonaniu opłaty za materiał.";
    } 
    else if (shippingForm === "Wysyłka pod wskazany adres"  && !this.props.claim.userDevice && dataFormat !== "drukowana") {
      if(dataSizeGiga < 4){
        text = "Podana opłata jest opłatą podstawową.\
        Opłata podstawowa zostanie powiększona o doliczony koszt wysyłki pocztowej.\
        Koszt wysyłki pocztowej zostanie podany przez Operatora systemu.\
        Zostaniesz poinformowany o tym po złożeniu wniosku." // <4
      }
      else if (dataSizeGiga >= 4 && dataSizeGiga < 20){
        text = `Podana opłata jest opłatą podstawową. 
        Opłata podstawowa zostanie powiększona o doliczony koszt wysyłki pocztowej. 
        Koszt wysyłki pocztowej zostanie podany przez Operatora systemu. Zostaniesz poinformowany o tym po złożeniu wniosku.
        Twoje zamówienie będzie miało pojemność ${sizeText}. W związku z tym do wartości zamówienia został dodany koszt nośnika. ` // 4-20
      }
      else if (dataSizeGiga >= 20){
        text = "Podana opłata jest opłatą podstawową.\
        Opłata podstawowa zostanie powiększona o doliczony koszt wysyłki pocztowej. Koszt wysyłki pocztowej zostanie podany przez Operatora systemu.\
        Zostaniesz poinformowany o tym po złożeniu wniosku.\
        W celu odbioru materiału, konieczne będzie dostarczenie własnego nośnika. Informacja na temat pojemności zamówionego materiału zostanie przekazana w wiadomości e-mail, po dokonaniu opłaty za materiał.";
      }
    } 
    //ÞŁATNA, DRUKOWANA
    else if (shippingForm === "Wysyłka pod wskazany adres" && dataFormat === "drukowana") {
      text = "Podana opłata jest opłatą podstawową.\
      Opłata podstawowa zostanie powiększona o doliczony koszt wysyłki pocztowej.\
      Koszt wysyłki pocztowej zostanie podany przez Operatora systemu.\
      Zostaniesz poinformowany o tym po złożeniu wniosku";
    } else if (shippingForm === "Odbiór osobisty" && dataFormat === "drukowana") {
      text = deliveryText;
    }
    if (this.props.claim.shortName === 'UdostepnienieMaterialowPublicznych') {
      text = "Przed udostępnieniem materiału, wniosek zostanie rozpatrzony przez Marszałka Województwa, decyzja zostanie podana w ciągu kilku dni roboczych, od dnia złożenia wniosku, o nastepnych krokach wnioskodawca zostanie poinformowany w wiadomościach mailowych.";
    }
    return (
      <div className="row">
        <h5 style={{ textAlign: 'justify' }}>
          <br />
          {text}
        </h5>
      </div>
    )
  }

  isPayablePurposePzgik = () => {
    const purpose = this.state.pzgik.celPobrMat; 
    const payablePurposes = ["dla dowolnych potrzeb", "dla potrzeb własnych niezwiązanych z działalnością gospodarczą, bez prawa publikacji w sieci Internet"]
    return payablePurposes.includes(purpose)
  }

  render() {
    const payableService = this.checkPayableService();
    const paymentMethod = _.find(this.props.paymentMethods, v => v.id === this.state.paymentMethod.id);
    if (!this.state.disablePayment && paymentMethod) {
      this.getPaymentStatus(paymentMethod);
    }
    const requestSubject = this.state.pzgik && this.getRequestSubject();
    return (
      <div className={s.root}>
        <div className={s.container}>
          {this.state.isMounted ? (
            <GrayPanel titleStyle={this.state.pzgik && {textAlign: 'center', 'fontWeight':'bold'}} title="Potwierdzenie złożenia wniosku">
              <h2 className={this.state.pzgik && s.sectionTitle}>Wniosek</h2>

              {/*
                  RENDER SERVICE NAME
              */}
              {!this.state.pzgik && <p className={s.sectionTitle}>
                <b>Nazwa usługi</b>
              </p>}
              <p className={s.sectionBody}>{this.props.eservices[this.props.claim.shortName].title}</p>

              {/*
                  RENDER SERVICE PARCELS LIST
              */}
              {this.props.claim.parcels.length > 0 ? (
                <div>
                <p className={s.sectionTitle}>
                  <b>Lista działek:</b>
                </p>
                <p className={s.sectionBody}>
                  {this.props.claim.parcels.map((v, i) => <span key={i}>{v.parcel}; </span>)}
              </p>
              </div>) : null}

              {/*
                  RENDER SERVICE DOCUMENTS TABLE
              */}
              {
                payableService && !this.state.pzgik ?
                  (_.includes(servicesWithOnlyApplication, this.props.claim.shortName) ?
                    <h2>Opłata za złożenie wniosku</h2> : <h2>Opłata za dokumenty</h2>
                  ) : null
              }
              {this.state.pzgik && this.props.claim.shortName !== 'UdostepnienieMaterialowPublicznych' ?
              (<div>
                <h2 className={s.sectionTitle}>Opłata za udostępnienie materiałów</h2>
                <p>
                  <b>{requestSubject}</b>
                </p>
              </div>) : (<div>
                <h2 className={s.sectionTitle}>Udostępnienie materiałów</h2>
                <p>
                  <b>{requestSubject}</b>
                </p>
              </div>)}
              {
                payableService ?
                  this.renderPaymentStatus(paymentMethod) : null
              }
              {
                payableService && !this.state.pzgik ?
                  (_.includes(servicesWithOnlyApplication, this.props.claim.shortName)
                    ? this.renderApplicationTable()
                    : this.renderDocumentsTable()
                  ) : null
              }
              { this.state.pzgik && <SummaryMaterialsTable requestSubject={requestSubject} shortName={this.props.claim.shortName} pzgik={this.state.pzgik} userDevice={this.props.claim.userDevice} isPayable={this.isPayablePurposePzgik()}/> }
              {/*
                  RENDER SERVICE DELIVERY AND PAYMENT METHODS
              */}
              {/*zmienic na skierniewice*/}
              {(this.props.claim.prefix === 'skierniewice' || this.props.claim.prefix === 'jawor') && (paymentMethod.fk_method == '3' && this.state.paymentStatus != 'waiting') ?
                null : this.renderPaymentDetails(payableService)}

              {this.state.pzgik && this.getSummaryTextPzgik()}

              {this.props.eservices[this.props.claim.shortName].confirmText ?
                <div className={s.subtitle}>
                  <input
                    name="isDefault"
                    type="checkbox"
                    style={{ marginLeft: '8px' }}
                    value={this.state.acceptApplication}
                    onChange={this.changeApplicationState}
                  />{' '}
                  &nbsp;&nbsp;&nbsp;
                <gwiazda style={{ color: 'red' }}>*</gwiazda>{' '}
                  {this.props.eservices[this.props.claim.shortName].confirmText}
                </div> : null}
              <br />
              <a
                className="btn btn-warning pull-left"
                target="_blank"
                href={`${process.env.API_URL}/eservices/getJobApplication/${
                  this.props.claim.jobId
                  }`}
                style={buttonPayStyle}
              >
                Pobierz wniosek
              </a>
              {/* {zmienic na skierniewice} */}
              {(this.props.claim.prefix === 'skierniewice' || this.props.claim.prefix === 'jawor') && paymentMethod && paymentMethod.fk_method == '3' && !this.props.eserviceDistrict.disablePayment ?
                this.renderPaymentButtons()
                :
                <button
                  onClick={() => this.goToSign()}
                  className="btn btn-primary pull-right"
                  style={buttonPayStyle}>
                  Złóż wniosek
                </button>}

            </GrayPanel>
          ) : (
              <GrayPanel
                title="Podsumowanie"
                bodyStyle={{
                  textAlign: 'center !important',
                  marginTop: '100px',
                  marginBottom: '100px',
                }}
              >
                <img role="presentation" src={waiting} />
                <a className="btn btn-warning pull-left" target="_blank" href={`${process.env.API_URL}/eservices/getJobApplication/${this.props.claim.jobId}`} style={buttonPayStyle}>Pobierz wniosek</a>
                {this.state.paymentMethod.label === 'Przelewem' || this.state.paymentMethod.label === 'W kasie urzędu' ?
                  <form method="post" target="_blank" action={`${process.env.API_URL}/eservices/jobPaymentPrint/${this.props.claim.jobId}`}>
                    <input
                      hidden type="text"
                      name="jobPaymentData"
                      value={
                        JSON.stringify(this.pdfData())
                      }
                    />
                    <input type="submit" value="Generuj druczek" className="btn btn-danger pull-left" rel="noopener noreferrer" style={buttonPayStyle} />
                  </form>
                  : null
                }
                <button onClick={() => this.goToSign()} className="btn btn-primary pull-right" style={buttonPayStyle}>Złóż wniosek</button>
              </GrayPanel>
            )}
          <ModalAlert
            title={this.state.errorTitle}
            bodyText={this.state.errorText}
            show={this.state.showError}
            name="errorModal"
            onHide={this.onHide}
          />
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  districts: state.district.districts,
  eservices: state.district.eservices
});

const mapDispatch = {
};

export default withStyles(s)(connect(mapState, mapDispatch)(EserviceSummary));


// http POST http://ihub2:8000/api/v1.0/paymentMethod label='W kasie urzędu'
// http POST http://ihub2:8000/api/v1.0/paymentMethod label='Przelewem'
// http POST http://ihub2:8000/api/v1.0/paymentMethod label='Płatność elektroniczna'

// http POST http://ihub2:8000/api/v1.0/deliveryMethods teryt=1815033 label='Wysyłka tradycyjna' protonID='23f27f8d-0a9e-47b2-807f-1fb59184dfea'
// http POST http://ihub2:8000/api/v1.0/deliveryMethods teryt=1815033 label='Wysyłka EPUAP' protonID='b9e7a426-8e1d-435e-8b3d-f0e11b4101d0'
// http POST http://ihub2:8000/api/v1.0/deliveryMethods teryt=1815033 label='Odbiór osobisty' protonID='d620cfe0-f272-40cd-9092-8fee0f59400b'



// WEBPACK FOOTER //
// src/routes/eserviceSummary/EserviceSummary.js